<div *ngIf="show" class="banner-advertisement">
  <div class="banner-container">
    <app-svg-icon class="banner-icon" src="./assets/icons/banner_advertisement.svg"></app-svg-icon>
    <div class="text-section">
      <div class="banner-section">
        <div class="banner-header">
          {{ 'module.banner-advertisement.bannerText1' | translate }}
        </div>
        <div class="banner-subheader">
          {{ 'module.banner-advertisement.bannerText2' | translate }}
        </div>
      </div>
      <div class="link-section">
        <a class="banner-link" (click)="dismissLink()">
          {{ 'module.banner-advertisement.linkText' | translate }}
        </a>
      </div>
    </div>
    <button class="btn exit-button" (click)="openLink()">
      {{ 'module.banner-advertisement.buttonText' | translate }}
    </button>
    <div class="close-button" (click)="closeLink()">
      <img class="x-icon" alt="close-icon" src="./assets/icons/close-icon-gray.svg" />
    </div>
  </div>
</div>
